import { render, staticRenderFns } from "./supplier-add.vue?vue&type=template&id=3fe64b4d&scoped=true"
import script from "./supplier-add.vue?vue&type=script&lang=js"
export * from "./supplier-add.vue?vue&type=script&lang=js"
import style0 from "./supplier-add.vue?vue&type=style&index=0&id=3fe64b4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe64b4d",
  null
  
)

export default component.exports